import React from 'react';

const BarberListHeaderColumn = () => (<div className="c-table-card__cell c-label u-2/10" />);

export default BarberListHeaderColumn;
